import { styled } from 'dripsy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';

import {
  BaseMobileHeader,
  BaseText,
  IconTouchable,
} from '@components';
import { screens, TabNavigatorNavigationPropType } from '@navigation';

const Title = styled(BaseText)({
  fontWeight: 'semi',
  color: '$heading800',
  variant: 'text.xxlarge',
});

type NavigationPropType = TabNavigatorNavigationPropType<'Hub'>;

export function HubHeader() {
  const { t } = useTranslation();
  const nav = useNavigation<NavigationPropType>();

  function navigateToFilters() {
    nav.navigate(screens.HubNavigator, { screen: screens.Filters });
  }

  return (
    <BaseMobileHeader
      LeftComponent={() => <Title>{t('hub.title')}</Title>}
      RightComponent={() => (
        <IconTouchable
          name="filter2-light"
          onPress={navigateToFilters}
        />
      )}
    />
  );
}
